import React, { useState } from 'react';
import {
  TooltipIcon,
  Link,
  InlineLoading,
  InlineLoadingStatus
} from 'carbon-components-react';
import {
  HelpFilled16,
  Subtract16,
  Copy16,
  Add16,
  Checkmark16
} from '@carbon/icons-react';
import { ReactComponent as UpdateNow } from 'assets/icons/update-now.svg';

export const Tools: React.FC<Props | any> = (props: Props) => {
  const {
    copyPageLinkHandler,
    copyPageLinkState,
    showCopyPageLink,
    autoRenewStatus
  } = props;
  const [showTools, setShowTools] = useState<boolean>(true);

  const handleToggleTools = () => {
    setShowTools(!showTools);
  };

  const renderCopyPageLinkIcon = () => {
    if (copyPageLinkState === 'active') {
      return (
        <InlineLoading
          className="get-responses-actions-tools-content-first-half-row-link-loading"
          status="active"
          aria-live="assertive"
        />
      );
    } else if (copyPageLinkState === 'error') {
      return (
        <InlineLoading
          className="get-responses-actions-tools-content-first-half-row-link-loading"
          status="error"
          aria-live="assertive"
        />
      );
    } else if (copyPageLinkState === 'finished') {
      return <Checkmark16 className="success" />;
    }
    return <Copy16 />;
  };

  return (
    <div className="get-responses-actions-tools">
      <div
        className="get-responses-actions-tools-header"
        onClick={handleToggleTools}
      >
        <div>{showTools ? <Subtract16 /> : <Add16 />}</div>
        <div className="get-responses-actions-tools-header-text">TOOLS</div>
      </div>
      {showTools && (
        <div className="get-responses-actions-tools-content">
          <div className="get-responses-actions-tools-content-first-half">
            {showCopyPageLink ? (
              <div className="get-responses-actions-tools-content-first-half-row">
                <div className="get-responses-actions-tools-content-first-half-row-link">
                  {renderCopyPageLinkIcon()}
                  <div className="get-responses-actions-tools-content-first-half-row-link-text">
                    <Link
                      className={
                        copyPageLinkState === 'finished'
                          ? 'get-responses-actions-tools-content-success'
                          : ''
                      }
                      disabled={copyPageLinkState === 'active'}
                      onClick={copyPageLinkHandler}
                    >
                      {copyPageLinkState !== 'finished'
                        ? 'Copy page link'
                        : 'Copied'}
                    </Link>
                  </div>
                </div>
                <div className="get-responses-actions-tools-content-first-half-row-tooltip">
                  <TooltipIcon
                    tooltipText={
                      'Copy a link to this enquiry and share it with others. Note: the recipient must have a BYDA account.'
                    }
                    className="tooltip referral-history-tooltip"
                  >
                    <HelpFilled16 className="tooltip-icon" />
                  </TooltipIcon>
                </div>
              </div>
            ) : null}
          </div>
          <div className="get-responses-actions-tools-content-second-half-row">
            <div className="get-responses-actions-tools-content-second-half-row-link">
              <div className="get-responses-actions-tools-content-second-half-row-link-icon-ready-only">
                <UpdateNow width={16} height={16} />
              </div>
              <div className="get-responses-actions-tools-content-second-half-row-link-text-ready-only">
                Auto-renewing {autoRenewStatus}
              </div>
            </div>
            <div className="get-responses-actions-tools-content-first-half-row-tooltip">
              <TooltipIcon
                tooltipText={
                  'When auto-renew is enabled, a new enquiry will be submitted every 28 days from the original lodgement date.'
                }
                className="tooltip referral-history-tooltip"
              >
                <HelpFilled16 className="tooltip-icon" />
              </TooltipIcon>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

type ownProps = {
  copyPageLinkState: InlineLoadingStatus;
  copyPageLinkHandler: any;
  showCopyPageLink: boolean;
  autoRenewStatus: boolean;
};

type Props = ownProps;

Tools.displayName = 'Tools';

export default React.memo(Tools);
